import { Component, Input } from '@angular/core';

@Component({
  selector: 'what-description',
  templateUrl: './what-description.component.html',
  styleUrls: ['./what-description.component.scss'],
})
export class WhatDescriptionComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() image: 'classic' | 'layflat' = 'classic';
}
